import React from "react";

// Wave divider mimicking River Great Ouse.
// variant: "top" (points up) or "bottom" (points down)
// fill: CSS color for the wave shape
// bg: CSS color of the preceding section (shown above the wave)
const WaveDivider = ({ variant = "bottom", fill = "#FAFAFA", bg = "#0B2C5B", className = "" }) => {
  return (
    <div
      className={`relative w-full overflow-hidden leading-[0] ${className}`}
      style={{ backgroundColor: bg }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
        className="block w-full h-[80px] md:h-[120px]"
        style={{ transform: variant === "top" ? "rotate(180deg)" : "none" }}
      >
        <path
          d="M0,64 C240,120 480,0 720,40 C960,80 1200,120 1440,56 L1440,120 L0,120 Z"
          fill={fill}
        />
        <path
          d="M0,80 C240,40 480,120 720,80 C960,40 1200,100 1440,72 L1440,120 L0,120 Z"
          fill={fill}
          opacity="0.5"
        />
      </svg>
    </div>
  );
};

export default WaveDivider;
